module.exports = __webpack_public_path__ + "static/img/grandma_g.1a63a4c5.png";